// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade{-webkit-transition:opacity .38s;-o-transition:opacity .38s;transition:opacity .38s;opacity:0}.fadeIn{opacity:1}body{overflow-y:scroll}body.block-scroll{overflow:hidden;overflow-y:scroll!important;position:fixed;width:100%}", ""]);
// Exports
module.exports = exports;
